import { Button, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import styles from './authorize.module.scss';
import AuthorizeRequest from './authorizeRequest';
import NotAuthorizedByPCC from './notAuthorizedByPCC';
import { getUserSelectedRole } from '../../../infrastructure/backendService';

const AuthorizeTabs = () => {
    const [activeButton, setActiveButton] = useState<string | null>(null);
    const [selectedUserRole,setSelectedUserRole] = useState<any>(getUserSelectedRole())
    const [activeUserTabPresident,setActiveUserTabPresident] = useState<string>()
    const [activeUserTabChairman,setActiveUserTabChairman] = useState<string>()
    const [activeUserTabCC,setActiveUserTabCC] = useState<string>()
    const [tabInActive,setTabInActive] = useState<boolean>(false)
    const handleAuthorizeRequest = () => {
        setActiveButton('Authorize Request');
    };
    const handleAuthorizeCC = () => {
        setActiveButton('Not Authorized By Committee Chairs');
    }
    const handleAuthorizePresident = () => {
        setActiveButton('Not Authorized By President');
    }
    const handleAuthorizeChairman = () => {
        setActiveButton('Not Authorized By Chairman');
    }
    useEffect(() => {
        setActiveButton('Authorize Request');
    }, [])
useEffect(()=>{
switch(selectedUserRole){
    case 'President' :
        setActiveUserTabPresident('Treasurer');
        break;
    case 'Chairman' :    
      setActiveUserTabChairman('Treasurer');
      break;
    case 'Committeechairs' :
        setActiveUserTabCC('Treasurer') ;
        break;
     default:
        break;   
}
},[])

useEffect(()=>{
if(selectedUserRole.includes("Chairman - ") || selectedUserRole.includes("Chair-")){
    setTabInActive(true)
}
},[selectedUserRole])
    return (
        <Grid className={styles.authorizeTabMainComponent}>
            <Grid className={styles.authorizeTabComponent}>
                <Typography className={styles.typoGraphyHeading}>Authorize Expense Requests</Typography>
                <Grid style={{ marginTop: "20px" }}>
                    <Grid className={styles.buttonContainer}>
                        <Button
                            onClick={handleAuthorizeRequest}
                            className={activeButton === 'Authorize Request' ? `${styles.activeButton}` : ''}
                        ><span style={{ textTransform: 'none' }}>Authorize Request</span></Button>
                        {!tabInActive && 
                        <Button
                            className={activeButton === 'Not Authorized By Committee Chairs' ? styles.activeButton : ''}
                            onClick={handleAuthorizeCC}><span style={{ textTransform: 'none' }}>{`Not Authorized By ${activeUserTabCC || 'Committee Chairs'}`}</span>
                        </Button>
                        }
                      {!tabInActive &&
                        <Button
                            className={activeButton === 'Not Authorized By President' ? styles.activeButton : ''}
                            onClick={handleAuthorizePresident}
                        ><span style={{ textTransform: 'none' }}>{`Not Authorized By ${activeUserTabPresident || 'President'}`}</span>
                            </Button>
                        }
                        {!tabInActive && 
                            <Button
                            className={activeButton === 'Not Authorized By Chairman' ? styles.activeButton : ''}
                            onClick={handleAuthorizeChairman}><span style={{ textTransform: 'none' }}>{`Not Authorized By ${activeUserTabChairman || 'Chairman'}`}</span>
                        </Button>
                        }
                    </Grid>
                </Grid>
            </Grid>
            {activeButton === 'Authorize Request' && <AuthorizeRequest category={selectedUserRole} />}
            {activeButton === 'Not Authorized By Committee Chairs' && <NotAuthorizedByPCC category={activeUserTabCC || 'Committeechairs'} />}
            {activeButton === 'Not Authorized By President' && <NotAuthorizedByPCC category={activeUserTabPresident || 'President'} />}
            {activeButton === 'Not Authorized By Chairman' && <NotAuthorizedByPCC category={activeUserTabChairman || 'Chairman'} />}
        </Grid>
    )
}
export default AuthorizeTabs;